<template>
  <IconButton
    :class="$b()"
    plain
    v-bind="$attrs"
  >
    <svg :class="$b('circle-svg', { active: isActive })">
      <circle
        cx="50%"
        cy="50%"
        r="12"
        :class="$b('circle', { faded: true })"
      />
      <circle
        cx="50%"
        cy="50%"
        r="12"
        :class="$b('circle', { fill: true })"
        :style="{ stroke: `url(#IconStrokeGradient-${gradientId})` }"
      />
      <defs>
        <linearGradient
          :id="`IconStrokeGradient-${gradientId}`"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(20)"
        >
          <stop
            offset="0"
            stop-color="#5C0F99"
          />
          <stop
            offset="60%"
            stop-color="#3449B8"
          />
          <stop
            offset="100%"
            stop-color="#1799E1"
          />
        </linearGradient>
      </defs>
    </svg>
  </IconButton>
</template>

<script>
export default {
  name: 'TimerButton',
  props: {
    isActive: { type: Boolean, default: false },
    gradientId: { type: String, default: '' },
  },
}
</script>

<style lang="postcss">
.TimerButton__circle {
  @apply fill-transparent stroke-mid-grey stroke-1;
  stroke-linecap: butt;

  &--fill {
    @apply transition-opacity;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    stroke-opacity: 1;
    stroke-width: 2;

    .TimerButton__circle-svg--active & {
      animation: fillCircle 10s linear both;
    }
  }
}

@keyframes fillCircle {
  0% {
    stroke-dashoffset: 100;
  }

  to {
    stroke-dashoffset: 0;
  }
}

.TimerButton__circle-svg {
  @apply transition-transform -rotate-90 scale-[0.45]
    w-7 h-7;

  @screen md {
    @apply scale-[0.4]
      w-[37px] h-[37px];
  }

  &:hover {
    @apply -rotate-90 scale-[0.65];
  }

  &--active {
    @apply -rotate-90 scale-100;

    &:hover {
      @apply scale-110;
    }
  }
}
</style>
